import { useNavigate } from "react-router-dom";
import GradientButton from "../Components/Button/GradientButton";

const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      <div className="text-4xl font-bold mb-4">404 - Page Not Found</div>
      <p className="text-lg text-gray-600 mb-8">
        The page you're looking for does not exist.
      </p>
      <div className="flex space-x-4">
        <div className="w-10 h-10 rounded-full bg-orange-500"></div>
        <div className="w-10 h-10 rounded-full bg-orange-400"></div>
        <div className="w-10 h-10 rounded-full bg-orange-300"></div>
      </div>
      <GradientButton
        type="button"
        onClick={() => navigate("..")}
        className="mt-5"
      >
        Go Back
      </GradientButton>
    </div>
  );
};

export default PageNotFound;
